import { useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, ArrowLeft } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StaffLogin } from "@/components/staff/StaffLogin";
import { EnquiriesInbox } from "@/components/staff/EnquiriesInbox";
import { EmployeeManager } from "@/components/staff/EmployeeManager";

const StaffDashboard = () => {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("enquiries");

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <p className="font-mono-plex text-[#9A9A9A] text-sm">Checking session…</p>
      </div>
    );
  }
  if (user === false) return <StaffLogin />;

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <header className="border-b border-[#222222]">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-6 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <Link
              to="/"
              data-testid="staff-back-home"
              className="text-[#555555] hover:text-white transition-colors"
              title="Back to site"
            >
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <span className="font-display font-bold uppercase tracking-tight text-white text-lg">
              Manasa <span className="text-[#FF3B30]">/</span> Staff
            </span>
          </div>
          <div className="flex items-center gap-6">
            <span data-testid="staff-user-name" className="font-mono-plex text-[#9A9A9A] text-xs uppercase">
              {user.name} [{user.role}]
            </span>
            <button
              data-testid="staff-logout-btn"
              onClick={logout}
              className="border border-[#222222] hover:border-[#FF3B30] text-white px-4 py-2 font-mono-plex text-xs uppercase tracking-[0.2em] transition-colors flex items-center gap-2"
            >
              <LogOut className="w-3 h-3" /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-[1200px] mx-auto px-5 md:px-10 py-12">
        {user.role === "admin" && (
          <div className="flex gap-px bg-[#222222] border border-[#222222] w-fit mb-12">
            {[
              { key: "enquiries", label: "Enquiries" },
              { key: "team", label: "Team" },
            ].map((t) => (
              <button
                key={t.key}
                data-testid={`staff-tab-${t.key}`}
                onClick={() => setTab(t.key)}
                className={`px-6 py-3 font-mono-plex text-xs uppercase tracking-[0.2em] font-bold transition-colors ${
                  tab === t.key ? "bg-[#FF3B30] text-white" : "bg-[#0A0A0A] text-[#555555] hover:text-white"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        )}
        {tab === "team" && user.role === "admin" ? <EmployeeManager /> : <EnquiriesInbox />}
      </main>
    </div>
  );
};

export default function Staff() {
  return (
    <AuthProvider>
      <StaffDashboard />
    </AuthProvider>
  );
}
